import React from "react";
import { TICKET_PRIORITY_LABELS } from "constants/tickets";

/**
 * PriorityIndicator (SOUND-493)
 * -------------------------------------------------------
 * Tiny, table-friendly dot (+ optional label):
 *   urgent -> destructive (solid) · high -> warning (solid)
 *   normal -> muted (solid, quiet) · low -> muted (hollow)
 *
 * Pass `showLabel={false}` to render just the dot (dense / small screens).
 */

const TONE = {
  urgent: { text: "text-destructive", dot: "bg-destructive", hollow: false },
  high: { text: "text-warning", dot: "bg-warning", hollow: false },
  normal: { text: "text-muted-foreground", dot: "bg-muted-foreground", hollow: false },
  low: { text: "text-muted-foreground", dot: "bg-muted-foreground", hollow: true },
};

export default function PriorityIndicator({
  priority = "normal",
  showLabel = true,
  className = "",
}) {
  const tone = TONE[priority] || TONE.normal;
  const label = TICKET_PRIORITY_LABELS[priority] || priority;

  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-medium ${tone.text} ${className}`}
      title={`Priority: ${label}`}
    >
      <span
        className={
          tone.hollow
            ? "h-2 w-2 rounded-full border-[1.5px] border-current"
            : `h-2 w-2 rounded-full ${tone.dot}`
        }
        aria-hidden="true"
      />
      {showLabel && <span>{label}</span>}
    </span>
  );
}
